<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>警报点详情</el-breadcrumb-item>
        <el-breadcrumb-item>历史记录查询</el-breadcrumb-item>
        <el-breadcrumb-item>告警记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div class="handle_box">
        <el-select placeholder="告警类型" class="handle_input" v-model="GetAlarmRecordList.params.alarmType" @click.native="getAlarmRuleList"
                   filterable clearable>
          <el-option
            v-for="item in alarmRuleList.result.alarmRuleList"
            :label="item.alarmRuleName"
            :value="item.alarmRuleName">
          </el-option>
        </el-select>
        <el-date-picker placeholder="开始时间" class="handle_select" v-model="GetAlarmRecordList.params.startTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 130px"></el-date-picker>
        <el-date-picker placeholder="结束时间" class="handle_select" v-model="GetAlarmRecordList.params.endTime" value-format="yyyy-MM-dd HH:mm:ss" style="width: 130px"></el-date-picker>
        <el-button type="primary" style="margin-top: 40px; margin-left: 20px;" icon="el-icon-search" @click="getAlarmRecordList(2)">查询</el-button>
      </div>
      <el-table style="margin-top: 20px; font-size: 14px;" :data="alarmRecordList.result.alarmRecordList" v-loading="isLoading" height="350">
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <!--<el-table-column label="编号" prop="alarmRecordId" width="80"></el-table-column>-->
        <el-table-column label="告警警报点" prop="pointName" width="220"></el-table-column>
        <el-table-column label="告警类型" prop="alarmType" width="200"></el-table-column>
        <el-table-column label="告警时间" prop="alarmTime" width="200">
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span>&nbsp;{{scope.row.alarmTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="告警值" prop="alarmValue" ></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @current-change="getAlarmRecordList(1)"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="parseInt(alarmRecordList.result.page, 10) * 10"
          :current-page.sync="GetAlarmRecordList.params.pageNumber">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'AlartRecord',
  data (){
    return {
      isLoading: false,
      currentPage:1,
      direction:"rtl",
      labelPosition:'left',
      // 获取告警记录列表
      GetAlarmRecordList:{
        "version": 1,
        "method": "alarm.GetAlarmRecordList",
        "params": {
          "alarmPointId":"",
          "alarmType":"",
          "startTime":"",
          "endTime":"",
          "pageNumber": 1,
        },
        "token": "",
        "id": 0
      },
      // 告警记录列表
      alarmRecordList:{
        "version": 1,
        "result":{
          "alarmRecordList": [
            {
              "alarmRecordId":"",
              "alarmPointId": "",
              "alarmType": "",
              "alarmValue": "",
              "alarmTime": "",
            },
          ],
          "page":"",
        },
        "id": 0
      },
      // 获取警报点列表
      GetAlarmPointList:{
        "version": 1,
        "method": "alarmpoint.GetAlarmPointList",
        "params": {
          "pointName":null,
          "alarmPointType":null,
          "areaId":null
        },
        "token": "#",
        "id": 0
      },
      // 警报点列表
      alarmPointList:{
        "version": 1,
        "result":{
          "alarmPointList": [
            {
              "alarmPointId":  "",
              "pointName": "",
              "alarmPointType": "",
              "longitude": "",
              "latitude": "",
              "alarmRadius":"",
              "areaId":"",
              "installAt":"",
              "remark":""
            },
          ]
        },
        "id": 0
      },
      // 获取告警规则列表
      GetAlarmRuleList:{
        "version": 1,
        "method": "alarm.GetAlarmRuleList",
        "params": null,
        "token": "",
        "id": 0
      },
      // 告警规则列表
      alarmRuleList:{
        "version": 1,
        "result":{
          "alarmRuleList": [
            {
              "alarmRuleId": "",
              "alarmRuleName": "",
              "alarmAttribute": "",
              "symbol": "",
              "parameter1":"",
              "parameter2":"",
              "description":"",
              "flag":""
            },
          ]
        },
        "id": 0
      },

    }
  },
  methods:{
    // 获取警报点列表
    getAlarmPointList(){
      for (let val in this.GetAlarmPointList.params){
        if(this.GetAlarmPointList.params[val] === ""){
          this.GetAlarmPointList.params[val] = null;
        }
      }
      this.GetAlarmPointList.token = localStorage.getItem('token');
      console.log('获取警报点列表请求');
      console.log(this.GetAlarmPointList);
      this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
        console.log('获取警报点列表请求得到响应');
        console.log(res.data);
        this.alarmPointList = res.data;
      })
    },
    // 获取告警规则列表
    getAlarmRuleList(){
      this.GetAlarmRuleList.token = localStorage.getItem('token');
      console.log('获取告警规则列表');
      this.$axios.post(this.$mainUrl, this.GetAlarmRuleList).then(res=>{
        console.log('获取告警规则列表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.alarmRuleList = res.data;
        }else{
          this.$message({
            type:'error',
            message: '获取告警规则失败，' + res.data.error.message
          })
        }
      })
    },
    // 获取告警记录列表
    getAlarmRecordList(val){
      this.isLoading = true;
      for (let key in this.GetAlarmRecordList.params){
        if (this.GetAlarmRecordList.params[key] === ""){
          this.GetAlarmRecordList.params[key] = null;
        }
      }
      if(val ==2){
        this.GetAlarmRecordList.params.pageNumber = 1;
      }
      this.GetAlarmRecordList.token = localStorage.getItem('token');
      this.GetAlarmRecordList.params.alarmPointId = sessionStorage.getItem('alarmPointId')
      console.log('获取告警记录列表请求');
      console.log(this.GetAlarmRecordList);
      this.$axios.post(this.$mainUrl, this.GetAlarmRecordList).then(res=>{
        this.isLoading = false;
        console.log('获取告警记录列表得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message: '获取告警记录成功'
          })
          // this.alarmRecordList = res.data;
          this.alarmRecordList = JSON.parse(JSON.stringify(res.data).replace(/alarmRuleList/g, 'alarmRecordList'))
          console.log('告警记录列表');
          console.log(this.alarmRecordList);
        }else{
          this.$message({
            type:'error',
            message: '获取告警记录失败，' + res.data.error.message
          })
        }
      })
    },
    checkAlarmRecord(row){
      // 查看报警记录
      this.$store.commit('setAlarmRecordId', row.alarmRecordId);
      this.$router.push(('/alarmRecordDetail'));
    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
  },
  mounted(){
    this.getAlarmRecordList(1);
  }
}
</script>

<style scoped>
  .handle_input{
    width: 200px;
    height: 16px;
    margin-left: 20px;
    display: inline-block;

  }
  .handle_select{
    width: 120px;
    margin-left: 20px;
    display: inline-block;
  }
  .handle_box{
    margin-top: -30px;
  }
  .pagination{
    position: relative;
    float: right;
    margin-top: 20px;
    text-align: right;
  }
</style>
